// extracted by mini-css-extract-plugin
export default {"container":"Welcome_container__NV+Tc","loader":"Welcome_loader__Swg2w","errorNotification":"Welcome_errorNotification__3F7in","logo":"Welcome_logo__HnGn3"};